export {
  LocationSearchInput,
  LocationSearchInputHandle,
} from './LocationSearchInput';
